module.exports = __webpack_public_path__ + "img/70ba39c.png";